import React, {memo} from "react";

const IndexPage = () => {
    return (
        <div />
    )
};

export default memo(IndexPage);
